import { GoCheckCircleFill, GoAlertFill, GoSync } from "react-icons/go";
import { recordStatusTone } from "context/recordStatus";
import "./statusIndicator.css";

/**
 * StatusIndicator — a record's lifecycle status, as a mark rather than a pill.
 *
 * It is deliberately NOT a badge. On a record header the pill is spoken for: visibility is the one
 * thing a reader scans for, and a second pill beside it competes with it for the same glance. A
 * status also carries a quality a pill cannot — healthy, transient, or wrong — which reads faster
 * as a coloured glyph than as another outlined rectangle. So the status sits at the far end of the
 * title row, where it is out of the name's way and lands in the same place on every row.
 *
 * Three treatments, one per tone from context/recordStatus.js — the split is decided there, so this
 * component never re-states it and the two cannot drift apart:
 *   ready      check, green   — the steady state
 *   failed     alert, red     — the one value that asks for a person
 *   otherwise  sync, muted    — transient; something is happening and the record will move on
 *
 * The glyph is decorative: the word beside it already says the status, so it carries aria-hidden and
 * the text is the accessible name. Colour is never the only carrier.
 */
export default function StatusIndicator({ status, className = "" }) {
  if ( null == status || "" === status ) {
    return null;
  }
  const tone = recordStatusTone(status);
  const Icon = { ready: GoCheckCircleFill, failed: GoAlertFill, transient: GoSync }[tone];
  return (
    <span className={["record-status", "record-status-" + tone, className].filter(Boolean).join(" ")}>
      <Icon aria-hidden="true"/>
      {status}
    </span>
  );
}
